import React, { FC, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

interface IShareFreightModalProps {
  onClose: () => void;
  isOpen: boolean;
  portalName?: string;
  isShareButtonLoading?: boolean;
  showShareFreightButton?: boolean;
  onFreightSelect?: (encodedFreightId: string) => void;
  onShare?: () => void;
}

const ShareFreightModalMF = React.lazy(() => import('companyContactList/ShareFreightModal'));

const ShareFreightModal: FC<IShareFreightModalProps> = ({ ...props }) => (
  <ErrorBoundary fallbackRender={null}>
    <Suspense fallback={null}>
      <ShareFreightModalMF {...props} />
    </Suspense>
  </ErrorBoundary>
);

ShareFreightModal.defaultProps = {
  portalName: null,
  isShareButtonLoading: null,
  showShareFreightButton: null,
  onFreightSelect: null,
  onShare: null,
};

export default ShareFreightModal;
